var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 52,
    viewBox: "0 0 60 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1851 51.1611H0V0H59.1851V51.1611ZM1.46353 49.6968H57.7215V1.46426H1.46353V49.6968Z",
    fill: "#209BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5704 33.0337H0.731812V34.4979H58.5704V33.0337Z",
    fill: "#209BB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6842 0.761719H15.2207V33.766H16.6842V0.761719Z",
    fill: "#209BB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1144 0.849609H29.6509V50.3122H31.1144V0.849609Z",
    fill: "#209BB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5702 24.3066H30.4998V25.7709H58.5702V24.3066Z",
    fill: "#209BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup28);
export default __webpack_public_path__ + "static/media/Group28.dc44fdfab31102e15920e1b519c258a1.svg";
export { ForwardRef as ReactComponent };